import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../selectors/users';
import { Props } from './HomeSection';

type StateProps = Pick<Props, 'isOwner'>;
type OwnProps = Omit<Props, keyof StateProps>;

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({ isOwner: isCurrentUserProfileOwner(state) });

export default connect(mapStateToProps);
